import { render, staticRenderFns } from "./SpecialCheckFlows.vue?vue&type=template&id=20ad9d54&scoped=true"
import script from "./SpecialCheckFlows.vue?vue&type=script&lang=js"
export * from "./SpecialCheckFlows.vue?vue&type=script&lang=js"
import style0 from "./SpecialCheckFlows.vue?vue&type=style&index=0&id=20ad9d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad9d54",
  null
  
)

export default component.exports